import moment from "moment";

import { IndividualLight } from "@/Common/Api/Individuals/Dto/IndividualLight";
import { AttachedCommunicationsPopup } from "@/Common/Components/AttachedCommunications/AttachedCommunicationsPopup";
import { DateSelector } from "@/Common/Components/Inputs/DateSelector";
import { TextboxControl } from "@/Common/Components/Inputs/TextboxControl";
import { PortalStatusButton } from "@/Common/Components/Portal/PortalStatusIcon";
import { MyleHelper } from "@/Common/Helpers/MyleHelper";
import { NameHelper } from "@/Common/Helpers/NameHelper";
import { PortalHelper } from "@/Common/Helpers/PortalHelper";
import { AttachedCommunication } from "@/Common/Models/AttachedCommunication/AttachedCommunication";
import { AttachedCommunicationType } from "@/Common/Models/AttachedCommunication/AttachedCommunicationType";
import { Guid } from "@/Common/Models/Guid";
import { Person } from "@/Common/Models/Person/Person";
import * as LocalOperations from "@/Common/Operations/operations.local";
import * as LocalPatientOperations from "@/Common/Operations/operations.patient.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { AnnotationLogs } from "@/Documents/Components/DocumentView/AnnotationLogs";
import { CreateNoteInView } from "@/Documents/Components/DocumentView/CreateNoteInView";
import { DocumentActionHistoryView } from "@/Documents/Components/DocumentView/DocumentActionHistoryView";
import { DocumentViewState, IDocumentViewProps } from "@/Documents/Components/DocumentView/DocumentView";
import { RevokeApprovalModal } from "@/Documents/Components/DocumentView/RevokeApprovalModal";
import { DocumentViewActionRegistryView } from "@/Documents/Extensions/DocumentViewActionRegistry";
import { MedicalDocumentItem } from "@/Documents/Models/Medical/MedicalDocumentItem";
import { DocumentCreateEditUIModel } from "@/Documents/Models/UI/IDocumentCreateEditUIModel";
import { SendDocumentStrategy } from "@/Documents/Services/Portal/Strategies/SendDocumentStrategy";
import { SendToPortalPopup } from "@/Portal/Components/SendToPortalPopup";

class PatientDocumentView extends React.Component<IDocumentViewProps, DocumentViewState> {
    private readonly helper = new MyleHelper();
    private readonly isPortalEnabled: boolean = cacheStore.ClinicSettings_Portal.EnablePortalWebsite;
    private readonly isAnnotationEnabled: boolean = cacheStore.ClinicSettings.EnableDocumentInAppView;
    private readonly isSignOffHistoryEnabled: boolean = cacheStore.ClinicSettings.EnableDocumentSignoffHistory;

    constructor(props: IDocumentViewProps) {
        super(props);
        const initialState = new DocumentViewState();
        this.state = initialState;
    }

    public render(): JSX.Element {
        let doc = this.props.model.get("MedicalDocumentInfo");
        let docModel = this.props.model.get("MedicalDocumentInfo").Model;

        if (!docModel) {
            return null;
        }

        let documentDescription = $.trim(docModel.Subject).length > 0 ? docModel.Subject : cacheStore.GetString("AttachmentLabel");
        let headerDisplay = limitTextLength(documentDescription, 50);

        const canApprove = sessionStore.canApproveDocument();

        let documentSubClassLookupId = docModel.SubClassId;
        let documentClassLookup = cacheStore.GetLocalizedValueByLookupId(docModel.ClassId);
        let documentSubclassLookup = cacheStore.GetLocalizedValueByLookupId(documentSubClassLookupId);

        let documentDate = null;

        const documentAnnotationsLog = this.props.model.get("DocumentAnnotationsLog");

        if (this.props.model.get("SignOffByContactId") == null) {
            documentDate = <strong>{moment(docModel.ReceiptDate).format("YYYY/MM/D")}</strong>;
        }
        else {
            documentDate = (
                <div className="clearfix">
                    <div className="pull-left"><DateSelector id="doc_create_date" cssClass="" date={docModel.ReceiptDate} onSelectOp={LocalOperations.Documents.Edit_Set_Document_Date} dateFormat="dddd, MMM dd, yyyy" disabled={this.props.model.get("LockUI")} /></div>
                    <a className="pull-left" style={{ margin: "9px 0 0 15px" }} id="dp1-today" onClick={this.onTodayClick.bind(this)}>{cacheStore.GetString("TodayLabel")}</a>
                </div>
            );
        }

        let uploadedBy = "";
        let uploader = this.props.model.get("Clinicians")
            .toArray()
            .filter((c: Person) => c.ContactId === docModel.UploaderContactId);
        if (uploader.length > 0) {
            uploadedBy = uploader[0].NameWithPrefix;
        }

        let documentUploadDate = (docModel.UploadDate == null) ? <strong /> : <strong>{moment(docModel.UploadDate).format("YYYY/MM/DD") + " " + cacheStore.GetString("AtLabel") + " " + moment(docModel.UploadDate).format("HH:mm:ss")}</strong>;

        let docMapped = docModel.DocumentPathList.map(x => {
            if (x.CreationDate == null)
                x.CreationDate = docModel.UploadDate;
            if (x.UploaderContactId != null) {
                let lastUploader = this.props.model.get("Clinicians")
                    .toArray()
                    .filter((c: Person) => c.ContactId === x.UploaderContactId);
                if (lastUploader.length > 0)
                    x.UploaderName = lastUploader[0].NameWithPrefix;
            }
            return x;
        });
        docMapped = docMapped.sortByProperty(x => x.CreationDate);
        const documentsRender = docMapped.map((doc, idx) => {
            const readableFileName = this.helper.GetReadableFileName(doc.FileName);
            const docUrl = apiSettings.buildAppUrl(`api/medicalDocuments/downloadFile/${doc.Id}/${encodeURIComponent(readableFileName)}`, { auth: true });

            return (
                <div key={idx + "_doc"} style={{ display: "flex" }}>
                    <div className="ellipsis-auto" style={{ width: "250px" }}>
                        <a className="pointer" title={readableFileName} onClick={() => MyleHelper.OpenNewWindow(docUrl)}> {readableFileName}</a>
                    </div>
                    {doc.CreationDate != null
                        ? (
                            <div style={{ marginLeft: "5px", width: "165px" }}>
                                <strong>{moment(doc.CreationDate).format("YYYY/MM/DD") + " " + cacheStore.GetString("AtLabel") + " " + moment(doc.CreationDate).format("HH:mm:ss")}</strong>
                            </div>
                        )
                        : (
                            <div>
                                {documentUploadDate}
                            </div>
                        )
                    }
                    {!IsNullOrWhiteSpace(doc.UploaderName)
                        ? (
                            <div style={{ marginLeft: "5px" }}>
                                <strong>{cacheStore.GetString("byLabel") + " " + doc.UploaderName}</strong>
                            </div>
                        )
                        : (
                            <div style={{ marginLeft: "5px" }}>
                                {!IsNullOrWhiteSpace(uploadedBy) &&
                                    <strong> {cacheStore.GetString("byLabel") + " " + uploadedBy}</strong>
                                }
                            </div>
                        )
                    }
                </div>
            );
        });

        let emmiterCode = docModel.SendingFacilityID;
        let reportCode = docModel.SendingFacilityReport;
        let accompanyingSubClass = docModel.AccompanyingSubClass;
        let accompanyingMnemonic = docModel.AccompanyingMnemonic;
        const sourceAuthorName = docModel.SourceAuthorName;
        let observationDate = this.props.model.get("ObservationDate") ? moment(this.props.model.get("ObservationDate")).format("YYYY/MM/D") + " " + cacheStore.GetString("AtLabel") + " " + moment(this.props.model.get("ObservationDate")).format("HH:mm:ss") : "";
        let authoringDate = this.props.model.get("AuthoringDate") ? moment(this.props.model.get("AuthoringDate")).format("YYYY/MM/D") + " " + cacheStore.GetString("AtLabel") + " " + moment(this.props.model.get("AuthoringDate")).format("HH:mm:ss") : "";

        let notesRender = docModel.NoteInfoCollection.map(note => {
            let person = cacheStore.GetEmployeeByContactIdOrEmpty(note.ContactId);
            return (
                <div key={note.NoteId} className="row no-side-margin">
                    <div className="col-lg-2 note-author">
                        <strong>{person.PrefixLookup.GetValue()}
                            {person.LastName}, {person.FirstName}
                        </strong>

                        <div>{moment(note.NoteDate).format("YYYY/MM/DD") + " " + cacheStore.GetString("AtLabel") + " " + moment(note.NoteDate).format("HH:mm:ss")}</div>
                    </div>
                    <div className="col-lg-10">
                        <span className="cl-note">{note.NoteContent}</span>
                    </div>
                </div>
            );
        });

        let actionButton: any = null;

        let portalSyncButton: JSX.Element = null;

        if (this.isPortalEnabled && PortalHelper.shouldShowPortalShareButton(docModel.Patients)) {
            const buttonProps = PortalHelper.getPortalButtonPropsForShareableItem(doc);

            portalSyncButton = (
                <PortalStatusButton
                    icon="share"
                    className="push-left-5"
                    onClick={() => this.PortalStatusClicked(doc)}
                    {...buttonProps}
                />
            );
        }

        if (docModel.SignOffDate == null || docModel.SignOffByContactId == null || docModel.SignOffByContactId == "") {
            if (canApprove) {
                actionButton = (
                    <div>
                        <button onClick={() => { LocalEvent.Dispatch(LocalOperations.Documents.ReturnToSearch); }} className="btn btn-default push-right-5 glyf" style={{ verticalAlign: "bottom" }} data-cy="patientDocView-back">
                            <span className="glyphicon glyphicon-chevron-left" />
                            <span>{cacheStore.GetString("BackLabel")}</span>
                        </button>
                        <button onClick={this.onEditClick.bind(this)} style={{ marginRight: "5px", verticalAlign: "bottom" }} className="btn btn-primary push-right" data-cy="patientDocView-edit">{cacheStore.GetString("EDITLabel")}</button>
                        <button className="btn btn-primary" style={{ verticalAlign: "bottom" }} disabled={this.state.isApproveDisabled} onClick={this.onApproveClick.bind(this)} data-cy="patientDocView-approve">{cacheStore.GetString("ApproveLabel")}</button>
                        {portalSyncButton}
                    </div>
                );
            }
            else {
                actionButton = (
                    <div>
                        <button onClick={() => { LocalEvent.Dispatch(LocalOperations.Documents.ReturnToSearch); }} className="btn btn-default push-right-5 glyf" style={{ verticalAlign: "bottom" }}>
                            <span className="glyphicon glyphicon-chevron-left" />
                            <span>{cacheStore.GetString("BackLabel")}</span>
                        </button>
                        <button onClick={this.onEditClick.bind(this)} style={{ marginRight: "5px", verticalAlign: "bottom" }} className="btn btn-primary push-right">{cacheStore.GetString("EDITLabel")}</button>
                        <button className="btn btn-primary disabled" style={{ verticalAlign: "bottom" }} disabled={true} onClick={this.onApproveClick.bind(this)}>{cacheStore.GetString("ApproveLabel")}</button>
                        {portalSyncButton}
                    </div>
                );
            }
        }
        else {
            actionButton = (
                <div>
                    <button onClick={() => { LocalEvent.Dispatch(LocalOperations.Documents.ReturnToSearch); }} className="btn btn-default push-right-5 glyf" style={{ verticalAlign: "bottom" }}>
                        <span className="glyphicon glyphicon-chevron-left" />
                        <span>{cacheStore.GetString("BackLabel")}</span>
                    </button>
                    <button
                        onClick={this.onCancelClick.bind(this)}
                        className="btn btn-default push-right"
                        style={{ marginRight: "5px", verticalAlign: "bottom" }}
                    >
                        {cacheStore.GetString("CancelLabel")}
                    </button>
                    <button
                        className="btn btn-primary push-right-5"
                        style={{ verticalAlign: "bottom" }}
                        onClick={() => sessionStore.validatePrescriptionRenewalBeforeDocumentSave(docModel.PrescriptionRenewal, docModel.ClassId, () => this.onSaveApprovedClick())}
                    >
                        {cacheStore.GetString("SaveLabel")}
                    </button>
                    {sessionStore.isAdmin() &&
                        <button className="btn btn-danger" style={{ "verticalAlign": "bottom" }} onClick={() => sessionStore.dispatch(LocalOperations.Documents.View_UnapproveClick)} data-cy="patientDocView-revoke">{cacheStore.GetString("RevokeApprovalLabel")}</button>
                    }
                    {portalSyncButton}
                </div>
            );
        }

        let hrmStatus: string;
        if (this.props.model.get("SelectedHRMStatus")) {
            let selectedHRM = this.props.model.get("HRMStatusList")
                .filter(st => st.Key === this.props.model.get("SelectedHRMStatus"));

            if (selectedHRM && selectedHRM.size > 0)
                hrmStatus = selectedHRM.get(0).Value;
        }

        let lastModifiedRender = null;
        if (this.props.model.get("LastModifiedByDate")) {
            lastModifiedRender = DocumentCreateEditUIModel.generateDocumentViewFooter(
                this.props.model.get("LastModifiedBy"),
                cacheStore.GetString("LastModifiedByLabel"),
                this.props.model.get("LastModifiedByDate")
            );
        }

        let signOffRender = null;
        if (this.props.model.get("SignOffDate") != null && this.props.model.get("SignOffByContactId") != null && this.props.model.get("SignOffByContactId") != "") {
            signOffRender = DocumentCreateEditUIModel.generateDocumentViewFooter(
                this.props.model.get("SignOffByContactId"),
                cacheStore.GetString("ApprovedByLabel"),
                this.props.model.get("SignOffDate")
            );
        }

        let revokedByRender: string;
        if (this.props.model.get("RevokedOn") && this.props.model.get("RevokedByContactId")) {
            revokedByRender = DocumentCreateEditUIModel.generateDocumentViewFooter(
                this.props.model.get("RevokedByContactId"),
                cacheStore.GetString("RevokedByLabel"),
                this.props.model.get("RevokedOn")
            );
        }

        let sourceRender = null;
        if (this.props.model.get("SignOffByContactId") == null) {
            sourceRender = <strong data-cy="patientDocView-source">{docModel.Source}</strong>;
        }
        else {
            sourceRender = <TextboxControl disabled={this.props.model.get("LockUI")} autoCompleteItems={this.props.sources} value={docModel.Source} operation={LocalOperations.Documents.Edit_OnSourcesChange} onAutoCompleteSelectCallBackOperation={LocalOperations.Documents.Edit_OnSourcesChange} />;
        }

        let descriptionRender = null;
        if (this.props.model.get("SignOffByContactId") == null) {
            descriptionRender = <strong title="docModel.Subject" data-cy="patientDocView-description">{limitTextLength(docModel.Subject, 50)}</strong>;
        }
        else {
            descriptionRender = <TextboxControl disabled={this.props.model.get("LockUI")} autoCompleteItems={this.props.descriptions} value={docModel.Subject} operation={LocalOperations.Documents.Edit_OnDescriptionChange} onAutoCompleteSelectCallBackOperation={LocalOperations.Documents.Edit_OnDescriptionChange} />;
        }

        let noteControl = null;
        let addNoteBtnLink = <div style={{ marginBottom: "30px" }}><a onClick={this.showAddNoteControl.bind(this)}>{cacheStore.GetString("AddNoteLabel")}</a></div>;
        if (this.props.model.get("ShowNoteCreateForm") === true) {
            addNoteBtnLink = null;
            noteControl = (
                <div className="row no-side-margin">
                    <div className="columns col-lg-5 col-md-8 ">
                        <CreateNoteInView addNoteOperation={LocalOperations.Documents.View_AddNewNote} hideControlOperation={LocalOperations.Documents.View_HideNewNotesControl} />
                    </div>
                </div>
            );
        }

        let siteRender = null;
        let sites = cacheStore.SiteCache;
        if (sites.length > 1) {
            siteRender = (
                <div className="row no-side-margin">
                    <div className="col-lg-2 col-md-4  text-right-lg text-right-md">
                        <label className="form-label">{cacheStore.GetString("SitesLabel")}</label>
                    </div>
                    <div className="col-lg-10 col-md-8 ">
                        <strong>{cacheStore.GetSiteNameById(docModel.SiteId)}</strong>
                    </div>
                </div>
            );
        }

        return (
            <div className="sb-workspace tbc">
                {this.props.model.get("UnapprovePopupOpen") && (
                    <RevokeApprovalModal
                        onClose={() => sessionStore.dispatch(LocalOperations.Documents.View_UnapproveClick)}
                        document={doc}
                    />
                )}

                {this.props.documentTabModel.get("AttachedCommunicationsPopupOpen") && (
                    <AttachedCommunicationsPopup
                        controlId="attached_communications_documentview"
                        attachedCommunications={docModel.IndividualTaskLinkedItems}
                        leftPosition={this.props.documentTabModel.get("AttachedCommunicationsPopupX")}
                        topPosition={this.props.documentTabModel.get("AttachedCommunicationsPopupY")}
                        context={AttachedCommunicationType.Task}
                        handleRedirect={ac => this.taskRedirectClick(ac)}
                        handleClose={() => this.taskRedirectClose()}
                    />
                )}

                {this.props.documentTabModel.get("IsSendToPatientPortalPopupOpen") && (
                    <SendToPortalPopup
                        model={this.props.documentTabModel.get("PortalLinkedItemModel")}
                        strategy={new SendDocumentStrategy()}
                    />
                )}

                <div className="myle-page-header bottom-border">
                    <div className="row">
                        <div className="col-lg-12 col-md-12 ">
                            <p className="header-font-color uppercase">{cacheStore.GetString("DocumentsLabel")}</p>
                            {docModel.IsUrgent === false && <h3 title={documentDescription} className="thin-font">{headerDisplay}</h3>}
                            {docModel.IsUrgent === true && <h3 className="thin-font bold red-text">URGENT <span title={documentDescription} style={{ color: "#274771", fontSize: "16px" }}>{headerDisplay}</span></h3>}
                        </div>
                    </div>
                </div>
                <div className="scrollable no-x-overflow" data-hvar="60">
                    <div className="myle-doc-tb main-content myle-form documents">
                        <div className="row no-side-margin">
                            <div className="col-lg-2 col-md-4 text-right-lg text-right-md">
                                <label className="form-label">{cacheStore.GetString("PatientsLabel")}</label>
                            </div>
                            <div className="col-lg-10 col-md-8">
                                <span className="pull-right" style={{ marginRight: "10px" }}>
                                    <span style={{ marginRight: "10px" }}>
                                        <DocumentViewActionRegistryView
                                            documentId={doc.Model.Id as Guid}
                                            source={docModel.Source}
                                        />
                                    </span>
                                    <a onClick={this.sendTaskClick.bind(this)}>{cacheStore.GetString("NewTaskLabel")}</a>
                                    {docModel.IndividualTaskLinkedItems.any() && (
                                        <span
                                            style={{ marginLeft: "5px", cursor: "pointer" }}
                                            onClick={e => this.onTaskTrailClick(e)}
                                            className={docModel.AreAllTasksCompleted ? "circle-green" : "circle-orange"}
                                        >
                                            {docModel.IndividualTaskLinkedItems.length}
                                        </span>
                                    )}
                                </span>
                                {docModel.Patients.map((patient: IndividualLight, idx) => (
                                    <div key={"patient_" + idx}><a className="bold pointer">{NameHelper.formatFullNameForHasName(patient)}</a></div>
                                ))}
                            </div>
                        </div>

                        <div className="row no-side-margin">
                            <div className="col-lg-2 col-md-4  text-right-lg text-right-md">
                                <label className="form-label">{cacheStore.GetString("ResponsibleProvidersLabel")}</label>
                            </div>
                            <div className="col-lg-10 col-md-8 ">
                                {docModel.ResponsibleProviders.map((provider: IndividualLight, idx) => {
                                    let prefix = "";
                                    let prefixlookup = cacheStore.GetLookupById(provider.Prefix);
                                    if (prefixlookup != null)
                                        prefix = cacheStore.GetLocalizedValueByLookupId(prefixlookup.LookupID) + " ";

                                    return (<div key={"provider" + idx}><strong>{prefix}{provider.LastName}, {provider.FirstName}</strong></div>);
                                })}
                            </div>
                        </div>

                        <div className="row no-side-margin">
                            <div className="col-lg-2 col-md-4  text-right-lg text-right-md">
                                <label className="form-label">{cacheStore.GetString("ClassLabel")}</label>
                            </div>
                            <div className="col-lg-6 col-md-8 ">
                                {this.props.model.get("SignOffByContactId") == null && <strong data-cy="patientDocView-class">{documentClassLookup + ": " + documentSubclassLookup}</strong>}
                                {this.props.model.get("SignOffByContactId") != null && (
                                    <select className="form-control myle-control" onChange={this.OnClassSubClassSelectionChange.bind(this)}>
                                        {this.props.documentClasses.toArray().map(g => (
                                            <optgroup key={g.LookupId} label={cacheStore.GetLocalizedValueByLookupId(g.LookupId)}>
                                                {g.SubClasses.toArray().map(s => {
                                                    let isSelected = (documentSubClassLookupId === s.LookupId);
                                                    let formattedOuput = cacheStore.GetLocalizedValueByLookupId(g.LookupId) + " - " + cacheStore.GetLocalizedValueByLookupId(s.LookupId);

                                                    return (
                                                        <option
                                                            key={s.LookupId}
                                                            selected={isSelected}
                                                            value={g.LookupId + "&" + s.LookupId}
                                                        >
                                                            {formattedOuput}
                                                        </option>
                                                    );
                                                })}
                                            </optgroup>
                                        ))}
                                    </select>
                                )}
                            </div>
                        </div>
                        {siteRender}

                        <div className="row no-side-margin">
                            <div className="col-lg-2 col-md-4  text-right-lg text-right-md">
                                <label className="form-label">{cacheStore.GetString("SourceLabel")}</label>
                            </div>
                            <div className="col-lg-6 col-md-8 ">
                                {sourceRender}
                            </div>
                        </div>
                        <div className="row no-side-margin">
                            <div className="col-lg-2 col-md-4  text-right-lg text-right-md">
                                <label className="form-label">{cacheStore.GetString("UploadedByLabel")}</label>
                            </div>
                            <div className="col-lg-10 col-md-8 ">
                                <strong>{uploadedBy}</strong>
                            </div>
                        </div>
                        <div className="row no-side-margin">
                            <div className="col-lg-2 col-md-4  text-right-lg text-right-md">
                                <label className="form-label">{cacheStore.GetString("DescriptionDLabel")}</label>
                            </div>
                            <div className="col-lg-6 col-md-8 ">
                                {descriptionRender}
                            </div>
                        </div>
                        <div className="row no-side-margin">
                            <div className="col-lg-2 col-md-4  text-right-lg text-right-md">
                                <label className="form-label">{cacheStore.GetString("DocumentDateLabel")}</label>
                            </div>
                            <div className="col-lg-10 col-md-8 col-sm-4">
                                <strong>{documentDate}</strong>
                            </div>
                        </div>
                        <div className="row no-side-margin paddingbottom15">
                            <div className="col-lg-2 col-md-4  text-right-lg text-right-md">
                                <label className="form-label">{cacheStore.GetString("DocumentGridFilesLabel")}</label>
                            </div>
                            <div className="col-lg-10 col-md-8 ">
                                {documentsRender}
                            </div>
                        </div>

                        <div className="row no-side-margin additional_details">
                            <div className="col-lg-2 col-md-4  text-right-lg text-right-md">
                                <label className="form-label">{cacheStore.GetString("SendingFacilityIDDLabel")}</label>
                            </div>
                            <div className="col-lg-10 col-md-8 ">
                                <strong>{emmiterCode}</strong>
                            </div>
                        </div>

                        <div className="row no-side-margin additional_details ">
                            <div className="col-lg-2 col-md-4  text-right-lg text-right-md">
                                <label className="form-label">{cacheStore.GetString("SendingFacilitySenderFacilityReportDLabel")}</label>
                            </div>
                            <div className="col-lg-10 col-md-8 ">
                                <strong>{reportCode}</strong>
                            </div>
                        </div>

                        <div className="row no-side-margin additional_details ">
                            <div className="col-lg-2 col-md-4  text-right-lg text-right-md">
                                <label className="form-label">{cacheStore.GetString("AccompanyingSubClassLabel")}</label>
                            </div>
                            <div className="col-lg-10 col-md-8 ">
                                <strong>{accompanyingSubClass}</strong>
                            </div>
                        </div>

                        <div className="row no-side-margin additional_details ">
                            <div className="col-lg-2 col-md-4  text-right-lg text-right-md">
                                <label className="form-label">{cacheStore.GetString("AccompanyingMnemonicLabel")}</label>
                            </div>
                            <div className="col-lg-10 col-md-8 ">
                                <strong>{accompanyingMnemonic}</strong>
                            </div>
                        </div>

                        {cacheStore.ClinicSettings.EnableDocumentSourceAuthorField && (
                            <div className="row no-side-margin additional_details ">
                                <div className="col-lg-2 col-md-4  text-right-lg text-right-md">
                                    <label className="form-label">{cacheStore.GetString("SourceAuthorNameLabel")}</label>
                                </div>
                                <div className="col-lg-10 col-md-8 ">
                                    <strong>{sourceAuthorName}</strong>
                                </div>
                            </div>
                        )}

                        <div className="row no-side-margin additional_details ">
                            <div className="col-lg-2 col-md-4  text-right-lg text-right-md">
                                <label className="form-label">{cacheStore.GetString("AuthoringDateTimeLabel")}</label>
                            </div>
                            <div className="col-lg-10 col-md-8 ">
                                <strong>{authoringDate}</strong>
                            </div>
                        </div>

                        <div className="row no-side-margin additional_details ">
                            <div className="col-lg-2 col-md-4  text-right-lg text-right-md">
                                <label className="form-label">{cacheStore.GetString("ObservationDateTimeLabel")}</label>
                            </div>
                            <div className="col-lg-10 col-md-8 ">
                                <strong>{observationDate}</strong>
                            </div>
                        </div>

                        <div className="row no-side-margin additional_details ">
                            <div className="col-lg-2 col-md-4  text-right-lg text-right-md">
                                <label className="form-label">{cacheStore.GetString("HRMStatusDLabel")}</label>
                            </div>
                            <div className="col-lg-10 col-md-8 ">
                                <strong>{hrmStatus}</strong>
                            </div>
                        </div>

                        {this.isAnnotationEnabled && (
                            <div className="row additional_details ">
                                <div className="col-lg-2 col-md-4  text-right-lg text-right-md">
                                    <label className="form-label">{cacheStore.GetString("DocumentView_AnnotationLogsLabel")}</label>
                                </div>
                                <div className="col-lg-10 col-md-8">
                                    <AnnotationLogs logs={documentAnnotationsLog} />
                                </div>
                            </div>
                        )}
                        {this.isSignOffHistoryEnabled && (
                            <div className="row additional_details ">
                                <div className="col-lg-2 col-md-4  text-right-lg text-right-md">
                                    <label className="form-label">{cacheStore.GetString("SignOffHistoryLabel")}</label>
                                </div>
                                <div className="col-lg-10 col-md-8">
                                    <DocumentActionHistoryView history={this.props.model.get("DocumentActionHistoryLog")} />
                                </div>
                            </div>
                        )}
                        <div className="row no-side-margin ">
                            <div className="col-lg-2 col-md-4  text-right-lg text-right-md">
                                <label className="form-label">{cacheStore.GetString("NotesLabel")}</label>
                            </div>
                            <div className="col-lg-10 col-md-8 ">
                                {addNoteBtnLink}
                                {noteControl}
                                {notesRender}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="ws-subfooter">
                    <div className="row no-side-margin native document-approve-view">
                        <div className="col-md-6 col-sm-6">
                            <p className="footer-col-smtext">{signOffRender}</p>
                            <p className="footer-col-smtext">{revokedByRender}</p>
                            <p className="footer-col-smtext">{lastModifiedRender}</p>
                        </div>
                        <div className="col-md-6 col-sm-6 text-right-lg text-right-md">
                            {actionButton}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    private mutateState(mutation: (s: DocumentViewState) => void, then: any = null): void {
        let s = new DocumentViewState();
        mutation(s);
        this.setState(s, then);
    }

    public onCancelClick(): void {
        let operation = new LocalEvent(LocalOperations.Documents.Show_DocumentSearch);
        LocalEventDispatcher.dispatch(operation);
    }

    public onEditClick(): void {
        let operation = new LocalEvent(LocalOperations.Documents.View_ShowEdit);
        LocalEventDispatcher.dispatch(operation);
    }

    public onApproveClick(): void {
        this.mutateState(s => s.isApproveDisabled = true);

        let operation = new LocalEvent(LocalOperations.Documents.Edit_OnApproveClick);
        LocalEventDispatcher.dispatch(operation);
    }

    public OnClassSubClassSelectionChange(e: React.ChangeEvent<HTMLSelectElement>): void {
        let selected: string = e.target.value;
        let classes = selected.split("&");
        let operation = new LocalEvent(LocalOperations.Documents.Edit_SubClassChange);
        operation.AddItem("value_class", classes[0]);
        operation.AddItem("value_subclass", classes[1]);

        LocalEventDispatcher.dispatch(operation);
    }

    public onTodayClick(): void {
        let operation = new LocalEvent(LocalOperations.Documents.Edit_OnTodayClick);
        LocalEventDispatcher.dispatch(operation);
    }

    public onSaveApprovedClick(): void {
        let operation = new LocalEvent(LocalOperations.Documents.Edit_SaveApprovedDocument);
        LocalEventDispatcher.dispatch(operation);
    }

    public componentDidMount(): void {
        $(window).trigger("resize");
    }

    private showAddNoteControl(e: React.MouseEvent<HTMLAnchorElement>): void {
        e.preventDefault();
        let operation = new LocalEvent(LocalOperations.Documents.View_ShowNewNotesControl);
        LocalEventDispatcher.dispatch(operation);
    }

    private sendTaskClick(e: React.MouseEvent): void {
        e.preventDefault();
        sessionStore.dispatch(
            LocalOperations.SendTaskOrMessageModel.Show_TaskOrMessage_Popup,
            {
                isTask: true,
                documentInfo: this.props.model.get("MedicalDocumentInfo"),
                fromCreateView: true
            }
        );
    }

    private PortalStatusClicked(medicalDocumentItem: MedicalDocumentItem): void {
        let operation = new LocalEvent(LocalOperations.Documents.PortalStatusClicked);
        operation.AddItem("doc", medicalDocumentItem);
        LocalEventDispatcher.dispatch(operation);
    }

    private onTaskTrailClick(e: React.MouseEvent<HTMLSpanElement>): void {
        e.stopPropagation();

        sessionStore.dispatch(
            LocalOperations.Documents.View_TrailClick,
            {
                eventY: e.clientY,
                eventX: e.clientX
            }
        );
    }

    private taskRedirectClick(attachedCommunication: AttachedCommunication): void {
        sessionStore.dispatch(
            LocalPatientOperations.History.TaskRedirectFromEncounterOrLabs,
            {
                attachedCommunications: [attachedCommunication],
                isFromDocument: true
            }
        );
    }

    private taskRedirectClose(): void {
        sessionStore.dispatch(LocalPatientOperations.History.AttachedCommunicationsClose);
    }
}

export { PatientDocumentView };
